export const SYM_ASYNC_ITERATOR: typeof Symbol.asyncIterator =
  Symbol.asyncIterator;
export const SYM_HAS_INSTANCE: typeof Symbol.hasInstance = Symbol.hasInstance;
export const SYM_IS_CONCAT_SPREADABLE: typeof Symbol.isConcatSpreadable =
  Symbol.isConcatSpreadable;
export const SYM_ITERATOR: typeof Symbol.iterator = Symbol.iterator;
export const SYM_MATCH: typeof Symbol.match = Symbol.match;
export const SYM_MATCH_ALL: typeof Symbol.matchAll = Symbol.matchAll;
export const SYM_REPLACE: typeof Symbol.replace = Symbol.replace;
export const SYM_SEARCH: typeof Symbol.search = Symbol.search;
export const SYM_SPECIES: typeof Symbol.species = Symbol.species;
export const SYM_SPLIT: typeof Symbol.split = Symbol.split;
export const SYM_TO_PRIMITIVE: typeof Symbol.toPrimitive = Symbol.toPrimitive;
export const SYM_TO_STRING_TAG: typeof Symbol.toStringTag = Symbol.toStringTag;
export const SYM_UNSCOPABLES: typeof Symbol.unscopables = Symbol.unscopables;

// For the future

// export const SYM_DISPOSE = Symbol.dispose;
// export const SYM_ASYNC_DISPOSE = Symbol.asyncDispose;
